var map = {
	"./call-accepted.mp3": "a78b",
	"./calling_forward.mp3": "32a3",
	"./calling_waiting_sound.mp3": "da7e",
	"./new-message.mp3": "6996",
	"./no_available_admins.mp3": "2019"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e5ea";